module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Kindred Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By Paul Alan Fahey")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“The sins of the fathers are visited upon the children.”")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("—Henrik Ibsen, "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005#a28"
    }
  }, [_vm._v("Chapter 1: A Damned Sensitive Soul")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a29"
    }
  }, [_vm._v("Chapter 2: Fire and Brimstone")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "href": "#/007#a30"
    }
  }, [_vm._v("Chapter 3: Big Things from Little Things Grow")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/008#a31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Leslie’s Premonition")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: A Death in the Family")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Act of Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/012#a35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Old Wounds")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/013#a36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Road to the Ruins")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Orphans’ Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Into the Past")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Brief Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/017#a40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Two Bits of Good News")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Freud and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/019#a42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: A Visit with Dot Perkins")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/020#a43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Freud Again")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/021#a44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: A Journey North")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/022#a45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: An Interview with Mrs. Rose Baker")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/023#a46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Facts and Suppositions")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/024#a47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: The Final Piece of the Puzzle")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/025#a48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Sins of the Fathers")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/026#a49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Kindred Spirits")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/027#a50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Home")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d298e64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0